import * as THREE from "three";
import { scene } from "./scene";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { ControlFunction } from "./controlFunction";
import { progressbar } from "./progressbar";

const loader = new GLTFLoader();

const loadAroundWeb = () => {
    const promiseAroundWeb = new Promise((resolve, reject) => {
        loader.load(
            "office/model/aroundweb/AroundWeb.gltf",
            function (gltf) {
                scene.add(gltf.scene);
                const model = gltf.scene;

                // Posizione iniziale da regolare con i controlli
                model.position.set(1.4238692992421256, 2.9694045166513408, 2.976169862090777);

                model.scale.set(1, 1, 1);
                model.rotation.set(0, 0, 0);

                // --- PARAMETRI MATERIALE REGOLABILI ---
                const roughnessValue = 50; // (0 = liscio/lucido, 1 = ruvido/opaco)
                const metalnessValue = 0; // (0 = non metallico, 1 = metallico)
                const emissiveValue = 0;  // (aggiunge luce propria se i colori sono troppo scuri)

                model.traverse(function (object) {
                    if (object.isMesh) {
                        object.castShadow = true;
                        object.receiveShadow = true;

                        if (object.material) {
                            object.material.roughness = roughnessValue;
                            object.material.metalness = metalnessValue;

                            if (object.material.emissive) {
                                object.material.emissiveIntensity = emissiveValue;
                            }

                            if (object.material.map) {
                                object.material.map.anisotropy = 1;
                                object.material.map.needsUpdate = true;
                            }
                        }
                    }
                });

                // Attiviamo i controlli per posizionarlo
                // ControlFunction(model);

                resolve(model);
                progressbar();
            },
            undefined,
            function (error) {
                console.error(error);
                reject(error);
            }
        );
    });
    return promiseAroundWeb;
};

export { loadAroundWeb };
